
export interface ContentModerationConfig {
  strictMode: boolean;
  autoRejectThresholds: {
    adult: string;
    racy: string;
    violence: string;
    medical: string;
  };
  autoApproveThresholds: {
    adult: string;
    racy: string;
    violence: string;
    medical: string;
  };
  appleStoreCompliance: {
    enabled: boolean;
    stricterThresholds: boolean;
    blockExplicitContent: boolean;
  };
  humanReviewRequired: string[];
  placeholderImage: string;
}

export const CONTENT_MODERATION_CONFIG: ContentModerationConfig = {
  strictMode: true, // Enable for production
  
  // Auto-reject thresholds (more restrictive for Apple Store)
  autoRejectThresholds: {
    adult: 'POSSIBLE', // Reject even possible adult content
    racy: 'POSSIBLE',  // Reject even possible racy content
    violence: 'LIKELY', // Reject likely violent content
    medical: 'VERY_LIKELY' // Reject very likely medical content
  },
  
  // Auto-approve thresholds (very conservative)
  autoApproveThresholds: {
    adult: 'VERY_UNLIKELY',
    racy: 'UNLIKELY',
    violence: 'VERY_UNLIKELY',
    medical: 'UNLIKELY'
  },
  
  // Apple Store specific compliance
  appleStoreCompliance: {
    enabled: true,
    stricterThresholds: true,
    blockExplicitContent: true
  },
  
  // Content that requires human review
  humanReviewRequired: [
    'POSSIBLE', // Any "possible" flagged content needs human review
    'UNKNOWN'   // Unknown results need human review
  ],
  
  placeholderImage: '/moderated-content-placeholder.svg'
};

export const MODERATION_MESSAGES = {
  REJECTED_ADULT: 'This image contains adult content and cannot be uploaded. Please choose a different image.',
  REJECTED_RACY: 'This image contains inappropriate content and cannot be uploaded. Please choose a different image.',
  REJECTED_VIOLENCE: 'This image contains violent content and cannot be uploaded. Please choose a different image.',
  REJECTED_MEDICAL: 'This image contains medical content and cannot be uploaded. Please choose a different image.',
  REJECTED_GENERAL: 'This image does not meet our community guidelines. Please choose a different image.',
  PENDING_REVIEW: 'Your image is being reviewed and will be available shortly.',
  SERVICE_UNAVAILABLE: 'Content verification is temporarily unavailable. Please try again later.'
};
